import { combineReducers } from 'redux';

import * as actions from '../actions';

function results(state = [], action) {
  switch (action.type) {
    case actions.SEARCH_COMPANY_SUCCESS:
      return action.data;
    case actions.RESET_COMPANY_LIST:
      return [];
    default:
      return Object.assign([], state);
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case actions.SEARCH_COMPANY_START:
      return true;
    case actions.SEARCH_COMPANY_SUCCESS:
    case actions.SEARCH_COMPANY_ERROR:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case actions.SEARCH_COMPANY_START:
    case actions.SEARCH_COMPANY_SUCCESS:
      return null;
    case actions.SEARCH_COMPANY_ERROR:
      return action.err.message || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

const search = combineReducers({
  results,
  loading,
  error,
});

export default search;
